const s = "115.0.1", e = "9.41.0";
export {
  s as designSystemVersion,
  e as designTokensVersion
};
